import cn from 'classnames';
import { FC } from 'react';

import classes from 'src/styles/_commonClasses.module.scss';
import { DataButton } from 'components/Shared/SharedComponents';
import { DataButtonInterface } from 'components/Shared/declarations';

import styles from './styles.module.scss';

const SubmitButton: FC<DataButtonInterface> = ({
  link,
  className,
  ...rest
}) => {
  if (!link) {
    return null;
  }

  return (
    // @ts-ignore
    <DataButton
      className={cn(styles.button, classes.cursorPointer, className)}
      {...rest}
    >
      {link.title}
    </DataButton>
  );
};

export default SubmitButton;
